import { observable, action } from 'mobx';
import { Decisions } from 'api';

class DecisionsStore {
  @observable decisions = [];

  @observable fetchState;

  @action.bound
  async getDecisions(anketId) {
    this.fetchState = 'pending';

    try {
      const response = await Decisions.getDecisions(anketId);
      this.decisions = response.data;
      this.fetchState = 'fulfilled';
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }
}

const decisionsStore = new DecisionsStore();

export default decisionsStore;
